import { render, staticRenderFns } from "./FormPurchaseDownPayment.vue?vue&type=template&id=0062213f"
import script from "./FormPurchaseDownPayment.vue?vue&type=script&lang=js"
export * from "./FormPurchaseDownPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports